import {
  CHANGE_BOOKING_DATE,
  CHANGE_BOOKING_DETAILS,
  CHANGE_BOOKING_ITEM_MILEAGE,
  CHANGE_BOOKING_ITEM_VARIATION,
  CHANGE_BOOKING_LOCATION,
  CHANGE_BOOKING_PEOPLE,
  CLEAR_LOCATION_ID,
} from './actions';
import { BookingDetails, BookingDetailsItemMileage } from './types';
import { initialOrderDetailsState, orderDetailsReducer } from './order_details';
import { cartReducer, initialCartState } from './cart';
import { dateToHourString } from '../utils/utils';
import { parseISO } from 'date-fns';

const initialDate = {
  fromDate: null,
  fromTime: '',
  suspectedToDate: null,
  toDate: null,
  toTime: '',
  selectedTimeSlot: null,
};

const initialState: BookingDetails = {
  ...initialDate,
  selectedMileageIds: {},
  selectedVariationIds: {},
  selectedLocationId: null,
  peopleNumber: 1,
  orderDetails: initialOrderDetailsState,
  cart: initialCartState,
};

export function bookingDetailsReducer(state = initialState, action: any): BookingDetails {
  switch (action.type) {
    case CHANGE_BOOKING_DATE: {
      return makeBookingDetailsState(
        {
          ...state,
          ...action.payload,
        },
        action,
      );
    }
    case CHANGE_BOOKING_ITEM_MILEAGE: {
      return makeBookingDetailsState(
        {
          ...state,
          selectedMileageIds: {
            ...state.selectedMileageIds,
            ...action.payload,
          },
        },
        action,
      );
    }
    case CHANGE_BOOKING_ITEM_VARIATION: {
      return makeBookingDetailsState(
        {
          ...state,
          selectedVariationIds: {
            ...state.selectedVariationIds,
            ...action.payload,
          },
        },
        action,
      );
    }
    case CHANGE_BOOKING_LOCATION: {
      return makeBookingDetailsState(
        {
          ...state,
          ...initialDate,
          selectedLocationId: action.payload,
        },
        action,
      );
    }
    case CHANGE_BOOKING_PEOPLE: {
      return makeBookingDetailsState(
        {
          ...state,
          peopleNumber: action.payload,
        },
        action,
      );
    }
    case CHANGE_BOOKING_DETAILS: {
      return makeBookingDetailsState(
        {
          ...state,
          ...action.payload,
        },
        action,
      );
    }
    case CLEAR_LOCATION_ID: {
      return makeBookingDetailsState(
        {
          ...state,
          selectedLocationId: null,
        },
        action,
      );
    }
    default: {
      return makeBookingDetailsState(state, action);
    }
  }
}

const makeBookingDetailsState = (state: BookingDetails, action) => {
  state = {
    ...state,
    orderDetails: orderDetailsReducer(state.orderDetails, action),
    cart: cartReducer(state.cart, action),
  };

  // update dates of booking from existing order
  if (state.orderDetails) {
    state = {
      ...state,
      fromDate: new Date(state.orderDetails.fromDate),
      toDate: new Date(state.orderDetails.toDate),
      fromTime: dateToHourString(parseISO(state.orderDetails.fromDate)),
      toTime: dateToHourString(parseISO(state.orderDetails.toDate)),
      selectedTimeSlot: state.orderDetails.timeSlotIntent,
      selectedLocationId: state.orderDetails.location.id,
    };
  }

  // update selected mileages from item in cart
  // - every item present in cart also has mileage in booking details
  if (state.cart) {
    const mileageItems = state.cart.items.filter(item => item.mileageOption);
    const mileagesObject = mileageItems.reduce((mileageObject: BookingDetailsItemMileage, item) => {
      return {
        ...mileageObject,
        [item.itemId]: item.mileageOption.id,
      };
    }, {});
    state = {
      ...state,
      selectedMileageIds: {
        ...state.selectedMileageIds,
        ...mileagesObject,
      },
    };
  }

  return state;
};
